<template>
  <div class="home">
    <div class="bg-decoration">
      <svg class="molecule-bg molecule-bg-1" viewBox="0 0 400 400" fill="none">
        <circle cx="200" cy="80" r="6" fill="#fca5a5" opacity="0.6"/>
        <circle cx="120" cy="140" r="5" fill="#fca5a5" opacity="0.5"/>
        <circle cx="280" cy="140" r="7" fill="#fca5a5" opacity="0.7"/>
        <circle cx="80" cy="220" r="4" fill="#fca5a5" opacity="0.4"/>
        <circle cx="200" cy="200" r="8" fill="#fca5a5" opacity="0.8"/>
        <circle cx="320" cy="220" r="5" fill="#fca5a5" opacity="0.5"/>
        <circle cx="150" cy="280" r="6" fill="#fca5a5" opacity="0.6"/>
        <circle cx="250" cy="280" r="5" fill="#fca5a5" opacity="0.5"/>
        <circle cx="200" cy="350" r="4" fill="#fca5a5" opacity="0.4"/>
        <line x1="200" y1="80" x2="120" y2="140" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="200" y1="80" x2="280" y2="140" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="120" y1="140" x2="80" y2="220" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="120" y1="140" x2="200" y2="200" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="280" y1="140" x2="200" y2="200" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="280" y1="140" x2="320" y2="220" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="200" y1="200" x2="150" y2="280" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="200" y1="200" x2="250" y2="280" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="150" y1="280" x2="200" y2="350" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="250" y1="280" x2="200" y2="350" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="80" y1="220" x2="150" y2="280" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="320" y1="220" x2="250" y2="280" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
      </svg>

      <svg class="molecule-bg molecule-bg-2" viewBox="0 0 300 300" fill="none">
        <circle cx="50" cy="150" r="5" fill="#fca5a5" opacity="0.5"/>
        <circle cx="100" cy="80" r="6" fill="#fca5a5" opacity="0.6"/>
        <circle cx="150" cy="150" r="7" fill="#fca5a5" opacity="0.7"/>
        <circle cx="100" cy="220" r="5" fill="#fca5a5" opacity="0.5"/>
        <circle cx="200" cy="100" r="4" fill="#fca5a5" opacity="0.4"/>
        <circle cx="250" cy="150" r="6" fill="#fca5a5" opacity="0.6"/>
        <circle cx="200" cy="200" r="5" fill="#fca5a5" opacity="0.5"/>
        <line x1="50" y1="150" x2="100" y2="80" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="100" y1="80" x2="150" y2="150" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="150" y1="150" x2="100" y2="220" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="150" y1="150" x2="200" y2="100" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="200" y1="100" x2="250" y2="150" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="250" y1="150" x2="200" y2="200" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
        <line x1="200" y1="200" x2="150" y2="150" stroke="#fca5a5" stroke-width="1" opacity="0.3"/>
      </svg>

      <svg class="dna-bg" viewBox="0 0 200 400" fill="none">
        <path d="M40 20 Q100 60 40 100 Q-20 140 40 180 Q100 220 40 260 Q-20 300 40 340 Q100 380 40 420" 
              stroke="#f87171" stroke-width="2" fill="none" opacity="0.2"/>
        <path d="M160 20 Q100 60 160 100 Q220 140 160 180 Q100 220 160 260 Q220 300 160 340 Q100 380 160 420" 
              stroke="#f87171" stroke-width="2" fill="none" opacity="0.2"/>
        <line x1="60" y1="60" x2="140" y2="60" stroke="#f87171" stroke-width="1" opacity="0.15"/>
        <line x1="50" y1="100" x2="150" y2="100" stroke="#f87171" stroke-width="1" opacity="0.15"/>
        <line x1="60" y1="140" x2="140" y2="140" stroke="#f87171" stroke-width="1" opacity="0.15"/>
        <line x1="50" y1="180" x2="150" y2="180" stroke="#f87171" stroke-width="1" opacity="0.15"/>
        <line x1="60" y1="220" x2="140" y2="220" stroke="#f87171" stroke-width="1" opacity="0.15"/>
        <line x1="50" y1="260" x2="150" y2="260" stroke="#f87171" stroke-width="1" opacity="0.15"/>
        <line x1="60" y1="300" x2="140" y2="300" stroke="#f87171" stroke-width="1" opacity="0.15"/>
        <line x1="50" y1="340" x2="150" y2="340" stroke="#f87171" stroke-width="1" opacity="0.15"/>
      </svg>

      <svg class="bars-bg" viewBox="0 0 200 300" fill="none">
        <rect x="10" y="150" width="12" height="150" fill="#fca5a5" opacity="0.15"/>
        <rect x="30" y="100" width="12" height="200" fill="#fca5a5" opacity="0.12"/>
        <rect x="50" y="120" width="12" height="180" fill="#fca5a5" opacity="0.18"/>
        <rect x="70" y="80" width="12" height="220" fill="#fca5a5" opacity="0.1"/>
        <rect x="90" y="140" width="12" height="160" fill="#fca5a5" opacity="0.15"/>
        <rect x="110" y="90" width="12" height="210" fill="#fca5a5" opacity="0.13"/>
        <rect x="130" y="110" width="12" height="190" fill="#fca5a5" opacity="0.16"/>
        <rect x="150" y="70" width="12" height="230" fill="#fca5a5" opacity="0.09"/>
        <rect x="170" y="130" width="12" height="170" fill="#fca5a5" opacity="0.14"/>
      </svg>

      <svg class="network-bg" viewBox="0 0 300 200" fill="none">
        <circle cx="50" cy="50" r="5" fill="#f87171" opacity="0.4"/>
        <circle cx="120" cy="30" r="4" fill="#f87171" opacity="0.3"/>
        <circle cx="200" cy="60" r="6" fill="#f87171" opacity="0.5"/>
        <circle cx="270" cy="40" r="5" fill="#f87171" opacity="0.4"/>
        <circle cx="80" cy="120" r="4" fill="#f87171" opacity="0.3"/>
        <circle cx="150" cy="100" r="7" fill="#f87171" opacity="0.6"/>
        <circle cx="230" cy="130" r="5" fill="#f87171" opacity="0.4"/>
        <circle cx="180" cy="170" r="6" fill="#f87171" opacity="0.5"/>
        <circle cx="100" cy="180" r="4" fill="#f87171" opacity="0.3"/>
        <line x1="50" y1="50" x2="120" y2="30" stroke="#f87171" stroke-width="1" opacity="0.2"/>
        <line x1="120" y1="30" x2="200" y2="60" stroke="#f87171" stroke-width="1" opacity="0.2"/>
        <line x1="200" y1="60" x2="270" y2="40" stroke="#f87171" stroke-width="1" opacity="0.2"/>
        <line x1="50" y1="50" x2="80" y2="120" stroke="#f87171" stroke-width="1" opacity="0.2"/>
        <line x1="80" y1="120" x2="150" y2="100" stroke="#f87171" stroke-width="1" opacity="0.2"/>
        <line x1="150" y1="100" x2="200" y2="60" stroke="#f87171" stroke-width="1" opacity="0.2"/>
        <line x1="150" y1="100" x2="230" y2="130" stroke="#f87171" stroke-width="1" opacity="0.2"/>
        <line x1="230" y1="130" x2="270" y2="40" stroke="#f87171" stroke-width="1" opacity="0.2"/>
        <line x1="80" y1="120" x2="100" y2="180" stroke="#f87171" stroke-width="1" opacity="0.2"/>
        <line x1="100" y1="180" x2="180" y2="170" stroke="#f87171" stroke-width="1" opacity="0.2"/>
        <line x1="180" y1="170" x2="230" y2="130" stroke="#f87171" stroke-width="1" opacity="0.2"/>
        <line x1="150" y1="100" x2="180" y2="170" stroke="#f87171" stroke-width="1" opacity="0.2"/>
      </svg>
    </div>

    <div class="home-content">
      <div class="welcome-section">
        <h1 class="welcome-title">Welcome to MetabHub</h1>
        <p class="welcome-subtitle">
          MetabHub is an integrative platform for exploring how clinical measurements, environmental exposures, and genetic variants are associated with incident diseases through plasma NMR metabolites. Based on individual-level UK Biobank data, MetabHub provides large-scale association and mediation evidence, metabolite-based disease prediction models, and metabolic risk score-based disease risk stratification.
        </p>
        <p class="welcome-subtitle">
          MetabHub helps researchers move from metabolite-disease association discovery to mechanism prioritization and translational risk assessment.
        </p>
      </div>

      <section class="intro-panel">
        <div class="intro-panel-image-wrap">
          <el-image
            class="intro-panel-image"
            src="/home_intro.png"
            alt="Sample & Variable Selection overview"
            :preview-src-list="['/home_intro.png']"
            fit="contain"
          />
        </div>
        <div class="intro-panel-copy">
          <h2 class="intro-panel-main-title">Main Modules</h2>

          <div class="intro-copy-block">
            <button class="intro-copy-title intro-copy-link" type="button" @click="navigateTo('/measurement')">Association &amp; Mediation</button>
            <p class="intro-copy-text">
              Explore potential metabolite-mediated pathways, including clinical measurement-metabolite-disease,
              environmental factor-metabolite-disease, and genotype-metabolite-disease relationships.
            </p>
          </div>

          <div class="intro-copy-block">
            <button class="intro-copy-title intro-copy-link" type="button" @click="navigateTo('/disease-risk-prediction')">Disease Risk Prediction</button>
            <p class="intro-copy-text">
              Browse optimized metabolite-based prediction models for incident diseases using penalized logistic
              regression, XGBoost, LightGBM, and multilayer perceptron. Users can also upload their own
              metabolomic data in CSV format to obtain disease probability estimates.
            </p>
          </div>

          <div class="intro-copy-block">
            <button class="intro-copy-title intro-copy-link" type="button" @click="navigateTo('/disease-risk-stratification')">Disease Risk Stratification</button>
            <p class="intro-copy-text">
              Investigate metabolic risk score-based survival results and compare disease risk across different
              metabolomic risk groups during long-term follow-up.
            </p>
          </div>

          <div class="intro-copy-block">
            <button class="intro-copy-title intro-copy-link" type="button" @click="navigateTo('/global-search')">Global Search</button>
            <p class="intro-copy-text">
              Search diseases, metabolites, clinical measurements, environmental factors, and genetic variants
              across MetabHub.
            </p>
          </div>

          <div class="intro-copy-block">
            <button class="intro-copy-title intro-copy-link" type="button" @click="navigateTo('/about')">Data Overview</button>
            <p class="intro-copy-text">
              MetabHub currently includes 364,795 European participants, 251 plasma NMR metabolomic traits,
              129 clinical measurement variables, 54 environmental exposure variables, genome-wide genetic variants,
              57 incident diseases, and approximately 14 years of longitudinal follow-up.
            </p>
          </div>

          <div class="intro-copy-block">
            <button class="intro-copy-title intro-copy-link" type="button" @click="navigateTo('/about')">Key Advantages</button>
            <p class="intro-copy-text">
              MetabHub integrates mediation analysis, machine learning-based disease prediction, online risk estimation,
              and metabolic risk score-based stratification in one interactive platform. It provides searchable tables,
              visual summaries, downloadable results, and user-friendly tools for metabolomics-driven disease research.
            </p>
          </div>
        </div>
      </section>

      <section class="feature-grid">
        <div class="section-heading">Association &amp; Mediation</div>
        <article class="feature-card feature-card-blue" @click="navigateTo('/gene')">
          <div class="feature-icon">
            <svg viewBox="0 0 64 64" fill="none">
              <path d="M24 8 Q32 16 24 24 Q16 32 24 40 Q32 48 24 56" stroke="#2563eb" stroke-width="3" fill="none" stroke-linecap="round"/>
              <path d="M40 8 Q32 16 40 24 Q48 32 40 40 Q32 48 40 56" stroke="#2563eb" stroke-width="3" fill="none" stroke-linecap="round"/>
              <line x1="26" y1="16" x2="38" y2="16" stroke="#2563eb" stroke-width="2" opacity="0.6"/>
              <line x1="25" y1="24" x2="39" y2="24" stroke="#2563eb" stroke-width="2" opacity="0.6"/>
              <line x1="26" y1="32" x2="38" y2="32" stroke="#2563eb" stroke-width="2" opacity="0.6"/>
              <line x1="25" y1="40" x2="39" y2="40" stroke="#2563eb" stroke-width="2" opacity="0.6"/>
              <line x1="26" y1="48" x2="38" y2="48" stroke="#2563eb" stroke-width="2" opacity="0.6"/>
            </svg>
          </div>
          <div class="feature-content">
            <h3 class="feature-title">Genotype</h3>
            <p class="feature-description">Explore genetic variants and their associations with traits and diseases.</p>
          </div>
        </article>

        <article class="feature-card feature-card-green" @click="navigateTo('/exposure')">
          <div class="feature-icon">
            <svg viewBox="0 0 64 64" fill="none">
              <path d="M32 56 L32 32" stroke="#16a34a" stroke-width="3" fill="none" stroke-linecap="round"/>
              <ellipse cx="24" cy="24" rx="14" ry="18" stroke="#16a34a" stroke-width="2" fill="#16a34a" opacity="0.24" transform="rotate(-30 24 24)"/>
              <ellipse cx="40" cy="24" rx="14" ry="18" stroke="#16a34a" stroke-width="2" fill="#16a34a" opacity="0.24" transform="rotate(30 40 24)"/>
              <path d="M18 20 Q24 28 30 24" stroke="#16a34a" stroke-width="1.5" fill="none" opacity="0.65"/>
              <path d="M34 24 Q40 28 46 20" stroke="#16a34a" stroke-width="1.5" fill="none" opacity="0.65"/>
            </svg>
          </div>
          <div class="feature-content">
            <h3 class="feature-title">Environment Factors</h3>
            <p class="feature-description">Explore environmental exposures and their impact on health outcomes.</p>
          </div>
        </article>

        <article class="feature-card feature-card-gold" @click="navigateTo('/measurement')">
          <div class="feature-icon">
            <svg viewBox="0 0 64 64" fill="none">
              <line x1="12" y1="52" x2="52" y2="52" stroke="#d97706" stroke-width="3" stroke-linecap="round"/>
              <rect x="16" y="30" width="6" height="18" rx="2" fill="#d97706" opacity="0.85"/>
              <rect x="29" y="22" width="6" height="26" rx="2" fill="#d97706" opacity="0.75"/>
              <rect x="42" y="14" width="6" height="34" rx="2" fill="#d97706" opacity="0.95"/>
              <path d="M16 20 L26 28 L34 20 L46 10" stroke="#d97706" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
              <circle cx="16" cy="20" r="2.5" fill="#d97706"/>
              <circle cx="26" cy="28" r="2.5" fill="#d97706"/>
              <circle cx="34" cy="20" r="2.5" fill="#d97706"/>
              <circle cx="46" cy="10" r="2.5" fill="#d97706"/>
            </svg>
          </div>
          <div class="feature-content">
            <h3 class="feature-title">Clinical Measurements</h3>
            <p class="feature-description">Browse and analyze clinical measurements and laboratory test results.</p>
          </div>
        </article>

        <article class="feature-card feature-card-red" @click="navigateTo('/global-search')">
          <div class="feature-icon">
            <svg viewBox="0 0 64 64" fill="none">
              <circle cx="28" cy="28" r="14" stroke="#dc2626" stroke-width="3"/>
              <path d="M38 38 L50 50" stroke="#dc2626" stroke-width="3" stroke-linecap="round"/>
              <circle cx="28" cy="28" r="6" fill="#dc2626" opacity="0.15"/>
            </svg>
          </div>
          <div class="feature-content">
            <h3 class="feature-title">Global Search</h3>
            <p class="feature-description">Search across cohorts, variables, diseases, and studies.</p>
          </div>
        </article>
      </section>

      <section class="module-section">
        <div class="section-heading">Disease Analysis</div>
        <div class="module-grid">
        <div class="card" @click="navigateTo('/disease-risk-prediction')">
          <div class="card-icon">
            <svg viewBox="0 0 64 64" fill="none">
              <rect x="12" y="8" width="32" height="48" rx="2" fill="#ef4444" opacity="0.2"/>
              <rect x="12" y="8" width="32" height="8" rx="2" fill="#ef4444" opacity="0.4"/>
              <line x1="18" y1="24" x2="38" y2="24" stroke="#ef4444" stroke-width="1.5" opacity="0.6"/>
              <line x1="18" y1="30" x2="38" y2="30" stroke="#ef4444" stroke-width="1.5" opacity="0.6"/>
              <line x1="18" y1="36" x2="30" y2="36" stroke="#ef4444" stroke-width="1.5" opacity="0.6"/>
              <circle cx="44" cy="40" r="12" fill="#ef4444" opacity="0.9"/>
              <line x1="40" y1="40" x2="48" y2="40" stroke="#ffffff" stroke-width="2"/>
              <line x1="44" y1="36" x2="44" y2="44" stroke="#ffffff" stroke-width="2"/>
              <path d="M50 46 L56 52" stroke="#ef4444" stroke-width="2" stroke-linecap="round"/>
              <circle cx="50" cy="46" r="4" fill="none" stroke="#ef4444" stroke-width="1.5" opacity="0.8"/>
              <circle cx="56" cy="52" r="3" fill="none" stroke="#ef4444" stroke-width="1.5" opacity="0.8"/>
              <line x1="46" y1="42" x2="54" y2="50" stroke="#ef4444" stroke-width="1.5" stroke-dasharray="2 2" opacity="0.5"/>
            </svg>
          </div>
          <div class="card-content">
            <h3 class="card-title">Disease Risk Prediction</h3>
            <!-- <p class="card-description">Explore representative disease cases such as Type 2 Diabetes and Hypertension</p> -->
            <div class="card-arrow">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </div>
          </div>
        </div>

        <div class="card" @click="navigateTo('/disease-risk-stratification')">
          <div class="card-icon">
            <svg viewBox="0 0 64 64" fill="none">
              <line x1="8" y1="56" x2="56" y2="56" stroke="#ef4444" stroke-width="2"/>
              <line x1="8" y1="8" x2="8" y2="56" stroke="#ef4444" stroke-width="2"/>
              <path d="M12 16 L24 16 L24 24 L36 24 L36 32 L44 32 L44 40 L52 40" 
                    stroke="#ef4444" stroke-width="3" fill="none" stroke-linecap="square"/>
              <line x1="12" y1="16" x2="12" y2="56" stroke="#ef4444" stroke-width="1" stroke-dasharray="2 2" opacity="0.3"/>
              <line x1="24" y1="24" x2="24" y2="56" stroke="#ef4444" stroke-width="1" stroke-dasharray="2 2" opacity="0.3"/>
              <line x1="36" y1="32" x2="36" y2="56" stroke="#ef4444" stroke-width="1" stroke-dasharray="2 2" opacity="0.3"/>
              <line x1="44" y1="40" x2="44" y2="56" stroke="#ef4444" stroke-width="1" stroke-dasharray="2 2" opacity="0.3"/>
              <line x1="52" y1="40" x2="52" y2="56" stroke="#ef4444" stroke-width="1" stroke-dasharray="2 2" opacity="0.3"/>
              <circle cx="12" cy="16" r="3" fill="#ef4444"/>
              <circle cx="24" cy="16" r="3" fill="#ef4444"/>
              <circle cx="24" cy="24" r="3" fill="#ef4444"/>
              <circle cx="36" cy="24" r="3" fill="#ef4444"/>
              <circle cx="36" cy="32" r="3" fill="#ef4444"/>
              <circle cx="44" cy="32" r="3" fill="#ef4444"/>
              <circle cx="44" cy="40" r="3" fill="#ef4444"/>
              <circle cx="52" cy="40" r="3" fill="#ef4444"/>
            </svg>
          </div>
          <div class="card-content">
            <h3 class="card-title">Disease Risk Stratification</h3>
            <!-- <p class="card-description">Explore risk stratification for Type 2 Diabetes and Hypertension</p> -->
            <div class="card-arrow">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </div>
          </div>
        </div>
        </div>
      </section>
<!-- 
      <section class="future-section">
        <div class="future-section-title">Upcoming modules</div>
        <div class="future-grid">
          <article class="future-card">
            <div class="future-step">2</div>
            <h3>Association &amp; Mediation</h3>
            <p>Results and mediation analysis panels will be added here.</p>
          </article>
          <article class="future-card">
            <div class="future-step">3</div>
            <h3>Disease Risk Prediction</h3>
            <p>Model evaluation, prediction curves, and exported results will live in this area.</p>
          </article>
          <article class="future-card">
            <div class="future-step">4</div>
            <h3>Disease Risk Stratification</h3>
            <p>Kaplan-Meier curves and stratified risk views will be implemented here.</p>
          </article>
        </div>
      </section> -->

      <footer class="home-footer">
        <div class="footer-content">
          <svg class="footer-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
            <line x1="2" y1="12" x2="22" y2="12"></line>
            <circle cx="12" cy="12" r="3"></circle>
          </svg>
          <span class="footer-item">UK Biobank</span>
          <span class="footer-dot">•</span>
          <span class="footer-item">Metabolomics</span>
          <span class="footer-dot">•</span>
          <span class="footer-item">Genomics</span>
          <span class="footer-dot">•</span>
          <span class="footer-item">Machine Learning</span>
          <svg class="footer-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
            <line x1="2" y1="12" x2="22" y2="12"></line>
            <circle cx="12" cy="12" r="3"></circle>
          </svg>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  methods: {
    navigateTo(path) {
      if (this.$route.path !== path) {
        this.$router.push(path)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  min-height: 100%;
  position: relative;
  overflow: hidden;
  background: linear-gradient(180deg, #fef2f2 0%, #ffffff 100%);
}

.bg-decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

.molecule-bg {
  position: absolute;

  &.molecule-bg-1 {
    width: 400px;
    height: 400px;
    top: 20px;
    left: -50px;
  }

  &.molecule-bg-2 {
    width: 300px;
    height: 300px;
    top: 100px;
    right: -80px;
  }
}

.dna-bg {
  position: absolute;
  width: 200px;
  height: 500px;
  top: -50px;
  right: 0;
}

.bars-bg {
  position: absolute;
  width: 200px;
  height: 300px;
  bottom: 80px;
  left: -20px;
}

.network-bg {
  position: absolute;
  width: 350px;
  height: 250px;
  bottom: 60px;
  right: -30px;
}

.home-content {
  position: relative;
  z-index: 1;
  margin: 0 auto;
  padding: 48px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(100vh - 64px);
}

.welcome-section {
  text-align: center;
  margin-bottom: 40px;
}

.welcome-title {
  font-size: 36px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 16px 0;
  line-height: 1.3;
}

.welcome-subtitle {
  font-size: 18px;
  color: #111827;
  margin: 0 auto;
  max-width: 920px;
  line-height: 1.8;
}

.welcome-subtitle + .welcome-subtitle {
  margin-top: 14px;
}

.intro-panel {
  width: 100%;
  background: rgba(255, 255, 255, 0.82);
  border: 1px solid rgba(239, 68, 68, 0.12);
  border-radius: 28px;
  box-shadow: 0 20px 50px rgba(127, 29, 29, 0.08);
  padding: 20px;
  margin-bottom: 28px;
  backdrop-filter: blur(8px);
  display: flex;
  align-items: stretch;
  gap: 24px;
}

.intro-panel-image-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 72%;
  min-width: 0;
}

.intro-panel-image {
  display: block;
  max-width: 100%;
  width: 100%;
  height: auto;
  border-radius: 18px;
  object-fit: cover;
}

:deep(.intro-panel-image .el-image__inner) {
  width: 100%;
  height: auto;
  border-radius: 18px;
  object-fit: cover;
}

.intro-panel-copy {
  flex: 0 0 28%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 4px 2px;
}

.intro-panel-main-title {
  margin: 0;
  color: #111827;
  font-size: 28px;
  line-height: 1.2;
  font-weight: 700;
}

.intro-copy-block {
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(239, 68, 68, 0.08);
}

.intro-copy-block:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}

.intro-copy-title {
  margin: 0 0 4px;
  color: #991b1b;
  font-size: 17px;
  line-height: 1.35;
  font-weight: 700;
}

.intro-copy-link {
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  text-align: left;
  transition: color 0.2s ease;
}

.intro-copy-link:hover {
  color: #b91c1c;
}

.intro-copy-text {
  margin: 0;
  color: #4b5563;
  font-size: 13px;
  line-height: 1.55;
}

.module-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  width: 100%;
}

.feature-grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  row-gap: 18px;
  margin-bottom: 36px;
}

.module-section {
  width: 100%;
  margin-bottom: 48px;
}

.section-heading {
  grid-column: 1 / -1;
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  line-height: 1.35;
}

.module-section .section-heading {
  margin-bottom: 18px;
}

.feature-card {
  position: relative;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 16px;
  padding: 18px 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 18px 36px rgba(15, 23, 42, 0.1);
  }
}

.feature-card::before {
  content: '';
  position: absolute;
  left: 0;
  top: 16px;
  bottom: 16px;
  width: 5px;
  border-radius: 999px;
}

.feature-card-blue::before {
  background: #2563eb;
}

.feature-card-green::before {
  background: #16a34a;
}

.feature-card-gold::before {
  background: #d97706;
}

.feature-card-red::before {
  background: #dc2626;
}

.feature-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(248, 250, 252, 0.9) 100%);
  border: 1px solid rgba(15, 23, 42, 0.08);

  svg {
    width: 42px;
    height: 42px;
  }
}

.feature-content {
  min-width: 0;
}

.feature-title {
  margin: 0 0 6px;
  color: #111827;
  font-size: 18px;
  line-height: 1.3;
}

.feature-description {
  margin: 0;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.5;
}

.card {
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  display: flex;
  gap: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgba(239, 68, 68, 0.1);

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    border-color: rgba(239, 68, 68, 0.3);
  }
}

.card-icon {
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  background: rgba(254, 242, 242, 0.8);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 40px;
    height: 40px;
  }
}

.card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.card-title {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 8px 0;
}

.card-description {
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 12px 0;
  line-height: 1.5;
}

.card-arrow {
  color: #ef4444;
  display: flex;
  align-items: center;

  svg {
    width: 20px;
    height: 20px;
  }
}

.home-footer {
  margin-top: auto;
  padding-top: 24px;
  width: 100%;
}

.footer-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 16px 0;
}

.footer-icon {
  width: 24px;
  height: 24px;
  color: #ef4444;
}

.footer-item {
  font-size: 14px;
  color: #6b7280;
}

.footer-dot {
  color: #ef4444;
  font-weight: 700;
}

.future-section {
  width: 100%;
  max-width: 1200px;
  margin-bottom: 24px;
}

.future-section-title {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 14px;
}

.future-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}

.future-card {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(239, 68, 68, 0.12);
  border-radius: 18px;
  padding: 18px;
  box-shadow: 0 12px 30px rgba(127, 29, 29, 0.06);
}

.future-step {
  width: 30px;
  height: 30px;
  border-radius: 9px;
  border: 1px solid rgba(239, 68, 68, 0.2);
  color: #ef4444;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 12px;
}

.future-card h3 {
  margin: 0 0 8px;
  font-size: 18px;
  color: #111827;
}

.future-card p {
  margin: 0;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.55;
}

@media (max-width: 768px) {
  .feature-grid,
  .module-grid,
  .future-grid {
    grid-template-columns: 1fr;
  }

  .welcome-title {
    font-size: 28px;
  }

  .home-content {
    padding: 32px 20px;
  }

  .intro-panel {
    padding: 14px;
    flex-direction: column;
  }

  .intro-panel-main-title {
    font-size: 18px;
  }
}
</style>
